'use client'

import { useEffect } from 'react'
import { captureEvent } from '@/lib/analytics'

// global-error replaces the root layout, so the app's stylesheets (Tailwind)
// never load here — styles must be self-contained in this embedded sheet.
const errorPageCss = `
  .global-error-body {
    margin: 0;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0a0a0a;
    color: #e5e5e5;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  }
  .global-error-card {
    text-align: center;
    padding: 2rem;
  }
  .global-error-title {
    font-size: 1.5rem;
    font-weight: 600;
  }
  .global-error-note {
    margin-top: 0.75rem;
    color: #a3a3a3;
  }
  .global-error-retry {
    margin-top: 1.5rem;
    padding: 0.5rem 1.5rem;
    border: 1px solid #e5e5e5;
    background: transparent;
    color: #e5e5e5;
    cursor: pointer;
  }
`

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    captureEvent('global_error', {
      message: error.message,
      digest: error.digest,
    })
  }, [error])

  return (
    <html lang="en">
      <body className="global-error-body">
        <style>{errorPageCss}</style>
        <div className="global-error-card">
          <h1 className="global-error-title">Something went wrong</h1>
          <p className="global-error-note">An unexpected error occurred.</p>
          <button type="button" onClick={reset} className="global-error-retry">
            {'<< TRY_AGAIN >>'}
          </button>
        </div>
      </body>
    </html>
  )
}
